import { isCSRUser } from 'src/utils';

const getHttpConfig = (headers) => ({
  headers: {
    'Content-Type': 'application/json',
    iscsruser: isCSRUser(),
    ...(headers || {})
  }
});

const http = {
  get: () => ({
    method: 'GET',
    ...getHttpConfig()
  }),
  post: (payload, headers) => ({
    method: 'POST',
    ...getHttpConfig(headers),
    body: JSON.stringify(payload)
  })
};

export default http;
